import styled from '@emotion/styled';
import { createElement, FC } from 'react';

type Props = {
  className?: string;
};

const InstagramDevice169: FC<Props> = (props) => (
  <Root viewBox="0 0 145.78 300.88" {...props}>
    <defs>
      <style>
        {
          '.insta16-9_svg__cls-1{fill:#fff}.insta16-9_svg__cls-2{fill:#424242}.insta16-9_svg__cls-3{fill:#eee}.insta16-9_svg__cls-4{fill:none;stroke:#f5f5f5;stroke-miterlimit:10}.insta16-9_svg__cls-5{fill:#9e9e9e}'
        }
      </style>
    </defs>
    <g id="insta16-9_svg__\u30EC\u30A4\u30E4\u30FC_2" data-name="\u30EC\u30A4\u30E4\u30FC 2">
      <g id="insta16-9_svg__\u30EC\u30A4\u30E4\u30FC_1-2" data-name="\u30EC\u30A4\u30E4\u30FC 1">
        <rect width={145.78} height={300.88} rx={21.72} />
        <path
          className="insta16-9_svg__cls-1"
          d="M6.28 39.65h131.78v36.92H6.28zM138 39.65v-18a14.29 14.29 0 00-14.25-14.32h-14.1v1.92a7.58 7.58 0 01-7.57 7.59h-59a7.58 7.58 0 01-7.58-7.59V7.33H20.56A14.3 14.3 0 006.28 21.64v18z"
        />
        <circle className="insta16-9_svg__cls-2" cx={18.79} cy={50.79} r={6.62} />
        <path className="insta16-9_svg__cls-3" d="M29.15 44.96h34.37v3.94H29.15zM29.15 51.05h55.23v4.21H29.15z" />
        <path
          className="insta16-9_svg__cls-1"
          d="M6.28 134.41v144.83a14.31 14.31 0 0014.31 14.31h103.1A14.31 14.31 0 00138 279.24V134.41z"
        />
        <rect x={53.71} y={286.02} width={34.73} height={3.52} rx={1.76} />
        <path className="insta16-9_svg__cls-4" d="M6.41 39.12h131.65M6.41 259.03h131.36" />
        <circle className="insta16-9_svg__cls-2" cx={20.18} cy={270.75} r={5.23} />
        <circle className="insta16-9_svg__cls-5" cx={45.34} cy={270.75} r={5.23} />
        <circle className="insta16-9_svg__cls-5" cx={70.51} cy={270.75} r={5.23} />
        <circle className="insta16-9_svg__cls-5" cx={95.67} cy={270.75} r={5.23} />
        <circle className="insta16-9_svg__cls-5" cx={17.16} cy={172.93} r={4.62} />
        <circle className="insta16-9_svg__cls-5" cx={32.23} cy={172.93} r={4.62} />
        <circle className="insta16-9_svg__cls-5" cx={47.3} cy={172.93} r={4.62} />
        <circle className="insta16-9_svg__cls-5" cx={124.02} cy={172.93} r={4.62} />
        <circle className="insta16-9_svg__cls-5" cx={120.83} cy={270.75} r={5.23} />
        <path
          className="insta16-9_svg__cls-3"
          d="M12.96 186.04h67.61v4.17H12.96zM12.96 192.67H121.6v4.45H12.96zM12.96 199.32h83.5v4.71h-83.5z"
        />
        <path className="insta16-9_svg__cls-2" d="M6.13 72.84h131.9v73.1H6.13z" />
        <circle className="insta16-9_svg__cls-2" cx={18.79} cy={236.81} r={6.62} />
        <path className="insta16-9_svg__cls-3" d="M29.15 230.97h34.37v3.94H29.15zM29.15 237.06h55.23v4.21H29.15z" />
      </g>
    </g>
  </Root>
);

const Root = styled('svg')();

export default InstagramDevice169;
